import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { IBreadcrumb } from '../../../common/types/listingOffers';
import { Section } from '../Section';

export interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumb[];
  handleBreadcrumbsClick(): void;
}

function getBreadcrumb(title: string, url: string, position: string, handleClickBreadcrumbs: () => void) {
  return (
    <li key={url} itemProp="itemListElement" itemType="http://schema.org/ListItem" itemScope>
      <a href={url} itemProp="item" onClick={handleClickBreadcrumbs}>
        <UIText2 display="inline" color="gray60_100" itemProp="name">
          {title}
        </UIText2>
      </a>
      <meta itemProp="position" content={position} />
    </li>
  );
}

export function Breadcrumbs({ breadcrumbs, handleBreadcrumbsClick }: IBreadcrumbsProps) {
  return (
    <Section tag="div" className={styles['container']} itemType="http://schema.org/BreadcrumbList" itemScope>
      <ul>
        {breadcrumbs.map((breadcrumb, index) => {
          return getBreadcrumb(breadcrumb.title, breadcrumb.url, String(index + 1), handleBreadcrumbsClick);
        })}
      </ul>
    </Section>
  );
}
